import React from 'react';
import { Price } from 'src/components/Helpers/Price';
import { useCreditBalance } from 'src/hooks/useCreditBalance';
import { useCustomerStatus } from 'src/features/user/lib/useCustomerStatus';
import classnames from 'classnames';

import classes from './MobileCreditBalance.scss';

export interface MobileCreditBalanceProps {
    showTopDivider?: boolean;
    showBottomDivider?: boolean;
    contentCentered?: boolean;
    smallPadding?: boolean;
    noPadding?: boolean;
    className?: string;
}

export const MobileCreditBalance: React.FC<MobileCreditBalanceProps> = ({
    showTopDivider = false,
    showBottomDivider = false,
    contentCentered = false,
    smallPadding = false,
    noPadding = false,
    className = '',
}) => {
    const { isSignedIn } = useCustomerStatus();
    const { creditAvailable, creditMax: rawCreditMax } = useCreditBalance(!isSignedIn);

    if (!isSignedIn || creditAvailable === undefined || creditAvailable <= 0) {
        return null;
    }

    // If creditMax is undefined or 0, use creditAvailable for display
    const creditMax = !rawCreditMax ? creditAvailable : rawCreditMax;

    return (
        <div
            className={classnames(classes.container, className, {
                [classes.smallPadding]: smallPadding,
                [classes.noPadding]: noPadding,
            })}
        >
            {showTopDivider && <div className={classes.divider} />}
            <div className={classnames(classes.contentContainer, { [classes.contentCentered]: contentCentered })}>
                <div className={classes.iconContainer}>
                    <img className={classes.icon} src={require('../../../static/icons/credit.svg')} alt="credit icon" />
                </div>
                <span className={classes.label}>Available Credit</span>
                <div className={classes.creditContainer}>
                    <Price className={classes.creditAvailable} price={creditAvailable} priceIncl={creditAvailable} />
                    <span className={classes.separator}>/</span>
                    <Price className={classes.creditMax} price={creditMax} priceIncl={creditMax} />
                </div>
            </div>

            {showBottomDivider && <div className={classes.divider} />}
        </div>
    );
};
